import { render, staticRenderFns } from "./PropertyCard.vue?vue&type=template&id=7df4154a&scoped=true&"
import script from "./PropertyCard.vue?vue&type=script&lang=js&"
export * from "./PropertyCard.vue?vue&type=script&lang=js&"
import style0 from "./PropertyCard.vue?vue&type=style&index=0&id=7df4154a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df4154a",
  null
  
)

export default component.exports